import { supabase } from "../supabaseClient";
export const getPopPlansForCP = async (cpId) => {
  try {
    // 1️⃣ Fetch POP plans
    const { data: plans, error } = await supabase
      .from("pop_plans")
      .select(`
        id,
        name,
        scope_type,
        start_date,
        end_date,
        status,
       docurl,
        pop_scope_entities (
          project_id,
          wing_id,
          unit_id,
          Projects (projectId, projectName),
          Wings (wingId, wingName),
          Inventory (unitId, unitNo)
        ),
        pop_slabs (
          id,
          from_value,
          to_value,
          percentage,
          amount,
          sort_order
        ),
        pop_cp_targets (cp_id)
      `)
      .is("deleted_at", null)
      .order("created_at", { ascending: false });

    if (error) throw error;

    // 2️⃣ Fetch CPSignOffs for this CP
    const { data: signoffs } = await supabase
      .from("CPSignOffs")
      .select("*")
      .eq("cpId", cpId);

    // 3️⃣ Filter by CP target
    const filteredPlans = plans.filter((plan) => {
      const targets = plan.pop_cp_targets;
      if (!targets || targets.length === 0) return true;
      return targets.some((t) => t.cp_id === cpId);
    });

const mergedPlans = filteredPlans.map((plan) => {
  const signoff = signoffs?.find(
    (s) => s.pop_plan_id === plan.id
  );

  return {
    ...plan,
    signoffStatus: signoff ? signoff.status : "Pending",
  esign_client_id: signoff?.esign_client_id || null,  // 👈 ADD THIS
  };
});

    return { data: mergedPlans, error: null };
  } catch (err) {
    console.error("Error fetching POP plans:", err.message);
    return { data: null, error: err.message };
  }
};





export const getAopPlansForCP = async (cpId) => {
  try {
    // 1️⃣ Fetch AOP plans
    const { data: plans, error } = await supabase
      .from("aop_plans")
      .select(`
        id,
        financial_year,
        status,
        sign_off_start_date,
        sign_off_end_date,
        accrual_basis,
        priority,
        is_locked,
        docurl,
         calculation_basis,
          reward_type,
        aop_slabs (
          id,
         
          from_value,
          to_value,
          percentage,
          amount,
          sort_order
        )
      `)
      .order("created_at", { ascending: false });

    if (error) throw error;

    // 2️⃣ Fetch CPSignOffs
    const { data: signoffs } = await supabase
      .from("CPSignOffs")
      .select("*")
      .eq("cpId", cpId);

    // 3️⃣ Merge status
    const mergedPlans = plans.map((plan) => {
      const signoff = signoffs?.find(
        (s) => s.aop_plan_id === plan.id
      );

      return {
        ...plan,
        signoffStatus: signoff ? signoff.status : "Pending",
      };
    });

    return { data: mergedPlans, error: null };
  } catch (err) {
    console.error("Error fetching AOP plans:", err.message);
    return { data: null, error: err.message };
  }
};


export const upsertCPSignoff = async ({
  planId,
  planType,
  cpId,
  status,
  reason = null,
}) => {
  try {
    let payload = {
      cpId,
      status,
      reason,
      updated_at: Date.now(),
    };

    if (planType === "POP") {
      payload.pop_plan_id = planId;
      payload.aop_plan_id = null;
    } else {
      payload.aop_plan_id = planId;
      payload.pop_plan_id = null;
    }

    const { data, error } = await supabase
      .from("CPSignOffs")
      .upsert(payload, {
        onConflict:
          planType === "POP"
            ? "pop_plan_id,cpId"
            : "aop_plan_id,cpId",
      });

    if (error) throw error;

    return { data, error: null };
  } catch (err) {
    console.error("Signoff error:", err.message);
    return { data: null, error: err.message };
  }
};

export const getBaseBrokeragePlans = async () => {
  try {
    const { data, error } = await supabase
      .from("base_brokerage_plans")
      .select(`
        id,
        name,
        calc_type,
        value,
        start_date,
        end_date,
        status,
        base_brokerage_plan_projects (
          project_id,
          Projects (projectId, projectName)
        )
      `)
      .is("deleted_at", null)
      .order("created_at", { ascending: false });

    if (error) throw error;

    return { data, error: null };
  } catch (err) {
    console.error("Error fetching Base Brokerage plans:", err.message);
    return { data: null, error: err.message };
  }
};